import React, { Fragment, useState } from 'react';
import moment from 'moment';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import Tooltip from '../../elements/Tooltip/Tooltip';
import { ReactComponent as Star } from '../../styles/icon/star.svg';
import { ReactComponent as InfoIcon } from '../../styles/icon/info.svg';
import { ReactComponent as BoundaryIcon } from '../../styles/icon/boundary.svg';
import strings from '../../lang/lang';

import app from './App.module.scss';

export default function AppCard(props) {
  const { head, desc, apiCount, createdDate, scopesInfo, link, type } = props;
  const [star, setActiveStar] = useState(false);

  return (
    <div className={app.app__wrap}>
      <Link className={app.app__card} to={link}>
        <div className={app.app__holder}>
          <div className={app.app__top}>
            <div className={app.app__name}>{head}</div>
            <div
              className={cn(app.app__icon, {
                [app['app__icon--active']]: star,
              })}
              onClick={(e) => {
                setActiveStar(!star);
                e.preventDefault();
              }}
            >
              <Star />
            </div>
            <div className={cn(app.app__type, {
              [app['app__type--b2b']]: type === 'B2B',
              [app['app__type--b2c']]: type === 'B2C',
            })}>{type}</div>
          </div>
          <div className={app.app__center}>
            <p className={app.app__description}>{desc || strings.appCard.text.noDescription}</p>
            <div className={app.app__date}>
              {strings.appCard.text.created} {moment.utc(createdDate).local().format('DD MMM YYYY')}
            </div>
          </div>
        </div>
        {!!apiCount && apiCount > 2 && (
          <div className={app.app__bottom}>
            <div className={app.app__btn}>
              <BoundaryIcon />
              <strong>{strings.appCard.text.apis + apiCount}</strong>
              <div className={app.app__icon_info}>
                <Tooltip
                  content={
                    <span>
                      <strong>{strings.appCard.text.appApis}</strong>
                      <p>
                        {scopesInfo &&
                          scopesInfo.map((item, index) => {
                            const _symbol = scopesInfo.length === index + 1 ? '.' : ', ';
                            return (
                              <Fragment key={item}>
                                `${item}${_symbol}`
                              </Fragment>
                            );
                          })}
                      </p>
                    </span>
                  }
                >
                  <InfoIcon />
                </Tooltip>
              </div>
            </div>
          </div>
        )}
        {!!apiCount && (apiCount === 1 || apiCount === 2) && (
          <Fragment>
            <div className={app.app__bottom}>
              {scopesInfo &&
                scopesInfo.map((item, index) => {
                  return (
                    <div key={item + index} className={cn(app.app__btn, 'app-btn')}>
                      <BoundaryIcon />
                      <strong>{item}</strong>
                    </div>
                  );
                })}
            </div>
          </Fragment>
        )}
      </Link>
    </div>
  );
}
